import React, { useEffect, useState } from "react"
import Layout from "../components/Layout/layout"
import SEO from "../components/seo"
import PropTypes from "prop-types"
import {
  notifsItemsContainer,
  notifItem,
  notificationDate,
  notificationInfos,
  notificationResume,
  notificationTitle,
} from "../styles/notifications.module.scss"

import TransitionFade from "../components/transition-fade"

function decodeHtmlEntities(str) {
  if (typeof document !== `undefined`) {
    const textarea = document.createElement("textarea")
    textarea.innerHTML = str
    return textarea.value
  }
  return null
}
const Notifications = () => {
  const [notificationsData, setNotificationsData] = useState(null)
  useEffect(() => {
    const urlNotifications =
      process.env.GATSBYSIDE_DRUPAL_URL +
      "/jsonapi/notification/notification?sort=-created"
    fetch(urlNotifications)
      .then((response) => {
        return response.json()
      })
      .then((resultNotifications) => {
        setNotificationsData(resultNotifications.data)
      })
  }, [setNotificationsData])
  return <RenderNotificationsInterface notificationsData={notificationsData} />
}

const RenderNotificationsInterface = ({ notificationsData }) => {
  const [numberOfItems, setNumberOfItems] = useState(20)
  if (notificationsData === null) {
    return null
  }
  let finalFilteredData = undefined
  let othersData = undefined
  finalFilteredData = notificationsData.slice(0, numberOfItems)
  othersData = notificationsData.slice(numberOfItems)
  return (
    <Layout message="Notifications">
      <SEO
        description="Page affichant toutes les notifications envoyées"
        title="Notifications"
      />
      <div className={notifsItemsContainer}>
        {notificationsData ? (
          <RenderNotifItems notificationsData={finalFilteredData} />
        ) : null}
        {othersData?.length > 0 && (
          <div className="voirPlus">
            <span
              role="button"
              tabIndex={0}
              onClick={() => setNumberOfItems(numberOfItems + 20)}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  setNumberOfItems(numberOfItems + 20)
                }
              }}
              className="btn"
            >
              Voir plus
            </span>
          </div>
        )}
      </div>
    </Layout>
  )
}
const RenderNotifItems = ({ notificationsData }) => {
  if (notificationsData.length === 0) {
    return <p style={{ margin: "0 2rem" }}>Pas de contenu à afficher.</p>
  }
  return (
    <>
      {notificationsData.map((node) => (
        <NotifItem key={node.id} notif={node} />
      ))}
    </>
  )
}

const NotifItem = ({ notif }) => {
  const date = new Date(notif.attributes.created).toLocaleDateString()
  if (notif.attributes.url == "/") {
    notif.attributes.url += "notifications"
  }
  return (
    <div className={notifItem}>
      {notif.attributes.image && (
        <TransitionFade
          arialabel={notif.attributes.titre}
          link={notif.attributes.url}
        >
          <img src={notif.attributes.image} />
        </TransitionFade>
      )}
      <div className={notificationInfos}>
        <div className={notificationDate}>envoyé le {date}</div>
        <h2 className={notificationTitle}>
          <TransitionFade link={notif.attributes.url}>
            {notif.attributes.titre}
          </TransitionFade>
        </h2>
        <div
          className={notificationResume}
          dangerouslySetInnerHTML={{
            __html:
              notif.attributes.contenu == null
                ? ""
                : decodeHtmlEntities(notif.attributes.contenu.processed),
          }}
        />
      </div>
    </div>
  )
}

Notifications.propTypes = {
  data: PropTypes.object.isRequired,
}

RenderNotificationsInterface.propTypes = {
  notificationsData: PropTypes.object.isRequired,
}

RenderNotifItems.propTypes = {
  notificationsData: PropTypes.object.isRequired,
}

NotifItem.propTypes = {
  notif: PropTypes.object.isRequired,
  colors: PropTypes.object,
}

export default Notifications
